var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "header_wrap" }, [
        _c(
          "div",
          { staticStyle: { width: "60%" } },
          [
            _c(
              "el-steps",
              {
                staticStyle: { width: "100%" },
                attrs: { "align-center": "", active: 1 }
              },
              [
                _c("el-step", {
                  attrs: {
                    title:
                      _vm.transportTypeCode == "KY"
                        ? _vm.$t("i18n_Air_Freight_Information")
                        : _vm.transportTypeCode == "HY"
                        ? _vm.$t("i18n_ocean_freight_information")
                        : _vm.transportTypeCode == "LY"
                        ? _vm.$t("i18n_land_transportation_information")
                        : ""
                  }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_Value_added_service") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_shipping_information") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_confirm_order") }
                }),
                _vm._v(" "),
                _c("el-step", {
                  attrs: { title: _vm.$t("i18n_order_completed") }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "center_wrap" }, [
        _c(
          "div",
          { staticClass: "wrap_l" },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _c("img", {
                  attrs: { src: require("../../assets/style.png"), alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "20px",
                      "font-family": "PingFang SC",
                      "font-weight": "500",
                      color: "#333333",
                      "margin-left": "10px"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("i18n_Value_added_service")) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.formData.feeItemDTOS, function(item, index) {
              return _c("div", { key: index }, [
                item.remark != "预估保费"
                  ? _c("div", { staticClass: "Item_list" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.remark != "预估保费",
                              expression: "item.remark != '预估保费'"
                            }
                          ],
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function($event) {
                                  return _vm.handleChange(item)
                                }
                              },
                              model: {
                                value: item.checked,
                                callback: function($$v) {
                                  _vm.$set(item, "checked", $$v)
                                },
                                expression: "item.checked"
                              }
                            },
                            [
                              item.feeCode === "CLEF"
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "i18n_customs_declaration_with_tax_refund"
                                        )
                                      )
                                    )
                                  ]
                                : [_vm._v(_vm._s(item.feeName))]
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.checked && item.feeCode != "INS",
                              expression:
                                "item.checked && item.feeCode != 'INS'"
                            }
                          ],
                          staticClass: "LR_center",
                          staticStyle: { width: "100%", float: "left" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "count_center",
                              staticStyle: {
                                padding: "25px 25px 0 25px",
                                "box-sizing": "border-box"
                              }
                            },
                            [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(_vm._s(item.priceDesc))
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    float: "left",
                                    "margin-left": "15px"
                                  }
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: { size: "mini", min: 1, max: 9999 },
                                    on: {
                                      change: function($event) {
                                        return _vm.handleChange(item)
                                      }
                                    },
                                    model: {
                                      value: item.num,
                                      callback: function($$v) {
                                        _vm.$set(item, "num", $$v)
                                      },
                                      expression: "item.num"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                padding: "25px 25px 0 25px",
                                "box-sizing": "border-box"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("i18n_estimated_cost")) +
                                  "：" +
                                  _vm._s(item.currency) +
                                  _vm._s(item.amount) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                item.checked &&
                                item.feeCode == "INS" &&
                                item.remark != "预估保费",
                              expression:
                                "\n              item.checked &&\n              item.feeCode == 'INS' &&\n              item.remark != '预估保费'\n            "
                            }
                          ],
                          staticClass: "LR_center_insurance",
                          staticStyle: { width: "100%", float: "left" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "LR_center_box" },
                            [
                              _c(
                                "el-form",
                                {
                                  ref: "ruleForm",
                                  refInFor: true,
                                  attrs: {
                                    model: _vm.insuranceData,
                                    rules: _vm.rules,
                                    "label-width": "110px"
                                  }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "费用类型:",
                                        prop: "chargeType",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          disabled: "",
                                          title: _vm.insuranceData.chargeType
                                        },
                                        model: {
                                          value: _vm.insuranceData.chargeType,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "chargeType",
                                              $$v
                                            )
                                          },
                                          expression: "insuranceData.chargeType"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: { width: "350px" },
                                      attrs: {
                                        label: "保额比例:",
                                        prop: "insuredAmount",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "200px" },
                                          attrs: { placeholder: "请选择" },
                                          model: {
                                            value:
                                              _vm.insuranceData.insuredAmount,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.insuranceData,
                                                "insuredAmount",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "insuranceData.insuredAmount"
                                          }
                                        },
                                        _vm._l(_vm.insuredAmountList, function(
                                          item,
                                          index
                                        ) {
                                          return _c("el-option", {
                                            key: index,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "品名:",
                                        prop: "goodsName",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          disabled: "",
                                          title: _vm.insuranceData.goodsName,
                                          placeholder: "请输入内容"
                                        },
                                        model: {
                                          value: _vm.insuranceData.goodsName,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "goodsName",
                                              $$v
                                            )
                                          },
                                          expression: "insuranceData.goodsName"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "箱数:",
                                        prop: "amount",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: { disabled: "" },
                                        model: {
                                          value: _vm.insuranceData.amount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "amount",
                                              $$v
                                            )
                                          },
                                          expression: "insuranceData.amount"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "PCS:",
                                        prop: "pcsAmount",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          type: "number",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: _vm.insuranceData.pcsAmount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "pcsAmount",
                                              $$v
                                            )
                                          },
                                          expression: "insuranceData.pcsAmount"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "单箱最低货值(CNY):",
                                        prop: "singleBoxMin",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          type: "number",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: _vm.insuranceData.singleBoxMin,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "singleBoxMin",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "insuranceData.singleBoxMin"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "单箱最高货值(CNY):",
                                        prop: "singleBoxMax",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          type: "number",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: _vm.insuranceData.singleBoxMax,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "singleBoxMax",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "insuranceData.singleBoxMax"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "总货值(CNY):",
                                        prop: "totalMount",
                                        "label-width": "150px"
                                      }
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          type: "number",
                                          placeholder: "请输入"
                                        },
                                        model: {
                                          value: _vm.insuranceData.totalMount,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.insuranceData,
                                              "totalMount",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "insuranceData.totalMount"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.insuranceData.chargeType == "KG"
                                    ? _c(
                                        "el-form-item",
                                        {
                                          staticStyle: { "margin-top": "20px" },
                                          attrs: {
                                            label: "总重量(KG):",
                                            prop: "weightTotal",
                                            "label-width": "150px"
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              disabled: "",
                                              type: "number"
                                            },
                                            model: {
                                              value:
                                                _vm.insuranceData.weightTotal,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.insuranceData,
                                                  "weightTotal",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "insuranceData.weightTotal"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-form-item",
                                    { staticStyle: { margin: "0px" } },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          on: {
                                            change: function($event) {
                                              return _vm.changeAllChecked()
                                            }
                                          },
                                          model: {
                                            value: _vm.isChosedSafe,
                                            callback: function($$v) {
                                              _vm.isChosedSafe = $$v
                                            },
                                            expression: "isChosedSafe"
                                          }
                                        },
                                        [
                                          _vm._v("我已阅读并同意"),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                color: "#5ab53c",
                                                cursor: "pointer",
                                                "text-decoration": "underline",
                                                margin: "0",
                                                padding: "0",
                                                "margin-left": "5px"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  $event.preventDefault()
                                                  return _vm.openPolicy()
                                                }
                                              }
                                            },
                                            [_vm._v("《投保服务协议》")]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        width: "300px",
                                        display: "flex",
                                        "justify-content": "center",
                                        gap: "20px",
                                        "margin-top": "10px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "count_center",
                                          staticStyle: {
                                            "box-sizing": "border-box"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              class: !_vm.showClickNext
                                                ? "animate__animated  animate__headShake  animate__bounceIn animate__pulse"
                                                : "",
                                              staticStyle: {
                                                width: "100%",
                                                background: "#5ab53c",
                                                color: "#ffffff"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.submitForm(
                                                    "ruleForm"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("确认")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "count_center",
                                          staticStyle: {
                                            "box-sizing": "border-box"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: {
                                                width: "100%",
                                                background: "#fff",
                                                color: "#303133"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.resetForm(
                                                    "ruleForm"
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("重置")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      item.remark && item.checked
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#ccc",
                                "padding-right": "25px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            *" +
                                  _vm._s(item.remark) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.formData.feeItemDTOS.length == 0,
                    expression: "formData.feeItemDTOS.length == 0"
                  }
                ],
                staticStyle: { padding: "20px" }
              },
              [
                _c("el-alert", {
                  attrs: {
                    closable: false,
                    title: _vm.$t("i18n_no_sevice_add"),
                    type: "warning",
                    description: _vm.$t("i18n_no_service_add_continue"),
                    "show-icon": ""
                  }
                })
              ],
              1
            )
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "OrderDetails" }, [
              _c(
                "div",
                {
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_shipping_cost")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.FBATransmoney.goodsTypeFeeDTOS, function(
                    item,
                    index
                  ) {
                    return _c("p", { key: index, staticClass: "coutText" }, [
                      _c("span", { staticClass: "littit" }, [
                        _vm._v(_vm._s(item.goodsTypeName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fontString" }, [
                        _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("(" + _vm._s(item.calDesc) + ")")
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.FBATransmoney.currency) +
                          _vm._s(_vm.FBATransmoney.amount)
                      )
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.THFdata.checked,
                      expression: "THFdata.checked"
                    }
                  ],
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_pickup_fee")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_pickup_at_original_port")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.THFdata.currency) +
                          _vm._s(_vm.THFdata.amount)
                      )
                    ]),
                    _vm._v(" "),
                    _vm.THFdata.maxKilometer > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "littit",
                            staticStyle: { float: "left", width: "100%" }
                          },
                          [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.THFdata.minKilometer) +
                                "--" +
                                _vm._s(_vm.THFdata.maxKilometer) +
                                ")\n              " +
                                _vm._s(_vm.$t("i18n_Kilometers"))
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.formData.totalExpense
                ? _c(
                    "div",
                    { staticClass: "Item_Right" },
                    [
                      _c("p", { staticClass: "tit" }, [
                        _vm._v(_vm._s(_vm.$t("i18n_Value_Added_Service_Fee")))
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.formData.feeItemDTOS, function(item, index) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.checked,
                                expression: "item.checked"
                              }
                            ],
                            key: index,
                            staticClass:
                              "coutText animate__animated animate__bounceInRight"
                          },
                          [
                            item.feeCode === "CLEF"
                              ? _c("span", { staticClass: "littit" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "i18n_customs_declaration_with_tax_refund"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", { staticClass: "littit" }, [
                                  _vm._v(_vm._s(item.feeName))
                                ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "fontString" }, [
                              _vm._v(
                                _vm._s(item.currency) +
                                  "  " +
                                  _vm._s(item.amount) +
                                  "  (" +
                                  _vm._s(item.calDesc) +
                                  ")"
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "coutText animate__animated animate__bounceInRight",
                          staticStyle: { color: "#ff3030" }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "littit",
                              staticStyle: { color: "#ff3030" }
                            },
                            [_vm._v(_vm._s(_vm.$t("i18n_subtotal")) + ":")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "fontString" }, [
                            _vm._v(_vm._s(_vm.formData.totalExpense))
                          ])
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "Item_Right" }, [
                _c(
                  "p",
                  {
                    staticClass: "coutText",
                    staticStyle: {
                      "justify-content": "flex-start",
                      gap: "10px"
                    }
                  },
                  [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_total_cost")))
                    ]),
                    _vm._v(" "),
                    _vm._l(this.newArray, function(item, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.amount > 0,
                              expression: "item.amount > 0"
                            }
                          ],
                          key: index
                        },
                        [
                          _c("span", [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.currency != "",
                                    expression: "item.currency != ''"
                                  }
                                ],
                                staticClass: "fontString"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.currency) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.amount > 0,
                                    expression: "item.amount > 0"
                                  }
                                ],
                                staticClass: "fontString",
                                staticStyle: {
                                  "margin-left": "5px",
                                  "margin-right": "5px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.amount) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    index == _vm.newArray.length - 1
                                      ? false
                                      : true,
                                  expression:
                                    "index == newArray.length - 1 ? false : true"
                                }
                              ]
                            },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [
                    _vm._v(_vm._s(_vm.$t("i18n_Covert_to_CNY")))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "goodsValueCount" }, [
                _c("div", { staticClass: "goodsValue_name" }, [
                  _vm._v("货值统计")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "goodsValue_fat" }, [
                  _c("div", { staticClass: "goodsValue_box" }, [
                    _vm._v("箱数:" + _vm._s(_vm.getBoxNum) + " 箱")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "goodsValue_value" }, [
                    _vm._v("货值:" + _vm._s(_vm.getGoodsValue) + " USD")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "30px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("i18n_Previousstep")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "div",
                      {
                        style: {
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                          borderRadius: "4px",
                          cursor: "pointer",
                          width: "100%",
                          height: "40px",
                          background:
                            this.showClickNext && this.bigCusShowClickNext
                              ? "#5ab53c"
                              : "gray",
                          color: "#ffffff"
                        },
                        attrs: {
                          title:
                            this.showClickNext && this.bigCusShowClickNext
                              ? ""
                              : "请重新确认保价信息"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pathToNext()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("i18n_Next_step")) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { center: "", visible: _vm.policyDialog, width: "50%" },
          on: {
            "update:visible": function($event) {
              _vm.policyDialog = $event
            }
          }
        },
        [
          _c("p", {
            staticStyle: { width: "100%" },
            domProps: { innerHTML: _vm._s(_vm.policyContent || "暂无数据") }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading.fullscreen.lock",
              value: _vm.calLoading,
              expression: "calLoading",
              modifiers: { fullscreen: true, lock: true }
            }
          ],
          staticStyle: { opacity: "0", cursor: "pointer" },
          attrs: { type: "primary" }
        },
        [_vm._v("\n    指令方式\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-da498cd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-da498cd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FBAorder/Fbaservice.vue
// module id = null
// module chunks = 